import React from "react";
import Photo from '../components/Photo';
import '../components/SinglePipe.scss';
export default ({isActive, image, message}) => {
  return (
    <div className="component fourth-component hide-overflow">
      <Photo photo={image} isActive={isActive} message={message} />
    </div>
  );
};
